module.exports = __webpack_public_path__ + "img/buy-car.65196746.jpeg";